/**
 * A aritmética de dinheiro e quantidade. Três funções, zero import.
 *
 * Ela morava em `pdv-pure.ts` e saiu de lá para desfazer um CICLO real:
 * `pdv-pure` reexporta `card-fees-pure` (para o terminal ter um import só) e
 * `card-fees-pure` importava `roundMoney`/`lineTotal`/`roundQty` de volta do
 * `pdv-pure`. Enquanto o barril de `@vertex/validators` entrava sempre pelo
 * lado do `pdv-pure`, o ciclo se resolvia por sorte; bastou um arquivo novo
 * importar `card-machines` antes para a ordem inverter e
 * `findCardFeeRule is not a function` aparecer em nove testes que ninguém
 * tinha tocado.
 *
 * Este arquivo é a FOLHA da árvore: ele não importa nada, então não há ciclo
 * possível. `pdv-pure.ts` continua reexportando tudo daqui e ninguém precisou
 * mudar de import.
 */

/**
 * Arredonda quantidade em 3 casas. Toda escrita e comparação de saldo passa
 * por aqui: a coluna é `double precision` (quantidade, não dinheiro) e sem
 * isso 0.1+0.2 vira 0.30000000000000004 no saldo.
 */
export function roundQty(n: number): number {
  return Math.round(n * 1000) / 1000;
}

/**
 * Arredonda dinheiro em centavos, meio pra cima de verdade.
 *
 * `Math.round(0.35 * 29.90 * 100)` dá 1046 e não 1047: 10.465 não é
 * representável em binário e cai 2e-15 abaixo. Com item vendido por peso isso
 * vira um centavo a menos em TODA venda fracionada. A folga de 1e-9 centavo
 * empurra o resíduo de volta pro lado certo e é pequena demais pra mexer num
 * valor que realmente esteja abaixo do meio centavo.
 */
export function roundMoney(n: number): number {
  return Math.round(n * 100 + 1e-9) / 100;
}

/** Total de uma linha: quantidade × preço unitário, em centavos exatos. */
export function lineTotal(qty: number, unitPrice: number): number {
  return roundMoney(roundQty(qty) * unitPrice);
}
